import React from 'react';
import Navbar from './Navbar';
import BreadCrumb from './BreadCrumb';
import Footer from './Footer';
import Download from './Download';
import Newsletter from './Newsletter';
import { FaArrowRight } from 'react-icons/fa';

const PrivacyPolicy = () => {
    return (
        <>
            <Navbar />
            <BreadCrumb />
            <div className="about-content" style={{ padding: '30px', backgroundColor: '#e7e7e7' }}>
                <section className="about-section mission">
                    <h1>Privacy Policy</h1>

                    <h3>1. Introduction</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        Welcome to RiseFX. We are committed to protecting your privacy. and ensuring that your personal data is handled securely and transparently. This Privacy Policy outlines how we collect, use, and safeguard your information in compliance with relevant data protection laws.
                    </p>

                    <h3>2. Information We Collect</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        We collect the following types of information:

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            Personal Data: Name, email, phone number, address, identity documents for KYC verification.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            Financial Data: Payment details, transaction history, deposits, and withdrawals.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            Technical Data: IP address, device information, cookies, and browsing data.
                        </h4>
                    </p>

                    <h3>3. How We Use Your Information</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            To verify your identity and process transactions.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            To enhance security and prevent fraudulent activities.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            To comply with legal and regulatory obligations.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                            To provide personalized customer support and marketing (if consented to).
                        </h4>
                    </p>

                    <h3>4. Data Protection & Security</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        We implement encryption, firewalls, and access control measures.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Sensitive data is stored securely and accessed only by authorized personnel.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        We do not sell or share your data with third parties without consent, except where required by law.
                        </h4>
                    </p>

                    <h3>5. Sharing of Information</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        With regulatory authorities for compliance purposes.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        With payment processors and banking partners.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        With third-party service providers who assist in operations.
                        </h4>
                    </p>

                    <h3>6. Cookies & Tracking Technologies</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        We use cookies to improve user experience and site functionality.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Users can manage cookie preferences through browser settings.
                        </h4>
                    </p>

                    <h3>7. Your Rights</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        You have the right to access, correct, or delete your personal data.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        You can withdraw consent for marketing communications at any time.
                        </h4>
                    </p>

                    <h3>8. Changes to This Policy</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        We may update this policy from time to time and will notify users of significant changes.
                        </h4>
                    </p>

                    <h3>9. Contact Information</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        For any privacy-related inquiries, contact us at <a href="mailto:enquiry@therisefx.com"> enquiry@therisefx.com.</a>
                        </h4>
                    </p>
                </section>
            </div>
            <Download />
            <Newsletter />
            <Footer />
        </>
    );
}

export default PrivacyPolicy;
